<template>
  <div class="flex-full">
    <head-image />
    <section class="container mt50">
      <div v-if="partnersWithDiscounts.length && loaded" class="row center-xs discounts-items px15">
        <div v-for="partner in partnersWithDiscounts" class="col-md-12">
          <h4 class="title-partner">
            <router-link class="name-partner" :to="partner.route">
              {{ partner.title }}
            </router-link>
          </h4>
          <div class="cart-flex">
              <div class="background-wrap relative mb20 between-xs"
                   v-for="(discount, index) in partner.promotions.filter(p => p.type === 'discount')"
                   :key="index"
              >
                <a class="link-partner" :href="discount.link ? discount.link : partner.route">
                  <div class="background" :style="{'background-image': 'url(' + discount.image + ')'}">
                    <div class="wrap">
                      <div class="title" v-html="discount.title"></div>
                      <div class="time">{{ discount.time }}</div>
                    </div>
                  </div>
                </a>
              </div>
          </div>
        </div>
      </div>
      <div v-else-if="!loaded">
        <bounce-loader />
        <p class="h3 mb50 mt50 align-center">
          Завантажуємо акції для Вас
        </p>
      </div>
      <div v-else>
        <p class="h3 mb50 mt50 align-center">
          Тут поки що немає акцій
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from 'config'
import { Logger } from '@vue-storefront/core/lib/logger'
import HeadImage from 'theme/components/core/blocks/MainSlider/HederDiscountsAll'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

export default {
  name: 'DiscountsAll',
  components: {
    HeadImage,
    BounceLoader
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      partners: 'partners/getPartnersByLocation'
    }),
    partnersWithDiscounts () {
      return this.partners.filter(p => p.promotions.length && p.active && p.enabled)
    }
  },
  data () {
    return {
      loaded: false
    }
  },
  methods: {
    ...mapActions({
      loadPartners: 'partners/loadPartners'
    })
  },
  async mounted () {
    // The store may hold a single partner or one category's page - this needs the whole city.
    if (this.currentLocation) {
      await this.loadPartners({ locationCode: this.currentLocation.code, include: config.partnersList.includes })
        .catch(err => Logger.error(err, 'sync')())
    }
    this.loaded = true
  },

  metaInfo () {
    return {
      title: this.currentLocation.discounts_meta_title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.currentLocation.discounts_meta_description
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.currentLocation.discounts_meta_keywords
        }]
    }
  }
}
</script>
<style lang="scss" scoped>
  .cart-flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media (max-width: 800px) {
      display: block;
    }
  }
  .title-partner{
    margin-bottom: 3%;
    margin-top: 0;
  }
  .name-partner{
    border-bottom: 1px solid #4f4f4f;
    font-size: 18px;
  }
  .h3{
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .discounts-items{
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .background-wrap{
    width: 345px;
    border-radius: 10px;
    overflow: hidden;

    @media (max-width: 375px){
      width: 304px;
    }
    @media (min-width: 769px){
      margin-left: 10px;
      margin-right: 10px;
    }
    .link-partner{
      position: static;
    }
  }
  .background{
    background-position: right top;
    background-repeat: no-repeat;
    height: 167px;
    text-align: left;

    .title{
      font-size: 16px;
      color: #fff;
      padding-left: 10px;
      margin-top: auto;
      span{
        display: inline;
        font-family: 'TTNorms Bold', sans-serif;
      }
    }
    .time{
      padding-left: 10px;
      font-size: 12px;
      color: #fff;
      opacity: 0.6;
      margin-top: auto;
      margin-bottom: 20px;
    }
    .wrap:after{
      content:'';
      position: absolute;
      left: 100%;
      top: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 83.5px 0 83.5px 20px;
      border-color: transparent transparent transparent #000000;
    }
    .wrap{
      display: flex;
      flex-direction: column;
      position: absolute;
      left: 0;
      top: 0;
      width: 170px;
      height: 100%;
      background-color: black;
    }



  }
</style>
<style lang="scss">
  .background{
    .title{
      span{
        display: inline;
        font-family: 'TTNorms Bold', sans-serif;
      }
    }
  }
</style>
